import { IExternalSystemService} from "../../domain/externalSystem";
import { IReplaceParameters } from "../../domain/document";
import { AuthenticatedService } from "..";

export class ExternalSystemService extends AuthenticatedService implements IExternalSystemService {
  constructor(getToken: () => string) {
    super(getToken);
  }


  async getData<TResult>(decodedUrl: string, replaceParameters?: IReplaceParameters): Promise<TResult> {
    const url = "/api/external-system/get";
    const query = {
      params: {
        encodedUrl: encodeURIComponent(decodedUrl.toString()),
        masterCode: replaceParameters ? replaceParameters.masterCode : "",
        formatOriginalId: replaceParameters ? replaceParameters.formatOriginalId : null,
        patientId: replaceParameters ? replaceParameters.patientId : "",
        userId: replaceParameters ? replaceParameters.userId : "",
      }
    };
    const result = await this.get(url, query);
    return result.data;
  }

  async postData<TData, TResult>(decodedUrl: string, data: TData): Promise<TResult> {
    const url = "/api/external-system/post";
    const result = await this.post(url, {
      url: encodeURIComponent(decodedUrl),
      data: JSON.stringify(data),
    });
    return result.data;
  }

  async validateUrl(decodedUrl: string): Promise<boolean> {
    const url = "/api/external-system/url/validate";
    const query = {
      params: {
        encodedUrl: encodeURIComponent(decodedUrl.toString()),
      }
    };
    const result = await this.get(url, query);
    return result.data as boolean;
  }
}
